export default "__VITE_ASSET__CKsZJjhl__"